"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_ga4_1 = __importDefault(require("react-ga4"));
var GoogleAnalytics = /** @class */ (function () {
    function GoogleAnalytics(trackingIds, prefix) {
        if (trackingIds === void 0) { trackingIds = []; }
        if (prefix === void 0) { prefix = "project"; }
        this.TRACKER_NAME = "tracker";
        this.SITE_SPEED_SAMPLE_RATE = 100;
        this.PAGE_VIEW_HINT_TYPE = "pageview";
        this.trackers = [];
        this.trackingIds = trackingIds;
        this.prefix = prefix;
    }
    GoogleAnalytics.prototype.build = function () {
        var uniqueIds = __spreadArray([], __read(new Set(this.trackingIds)), false);
        var trackings = [];
        for (var i = 0; i < uniqueIds.length; i++) {
            var trackerName = "".concat(this.prefix, "_").concat(this.TRACKER_NAME, "_").concat(i);
            var tracker = {
                trackingId: uniqueIds[i],
                gaOptions: {
                    name: trackerName,
                    siteSpeedSampleRate: this.SITE_SPEED_SAMPLE_RATE,
                },
            };
            this.trackers.push(trackerName);
            trackings.push(tracker);
        }
        react_ga4_1.default.initialize(trackings);
    };
    GoogleAnalytics.prototype.event = function (action, category) {
        react_ga4_1.default.event({ category: category, action: action });
    };
    GoogleAnalytics.prototype.dimensionEvent = function (action, category, label, value) {
        react_ga4_1.default.event({ category: category, action: action, label: label, value: value });
    };
    GoogleAnalytics.prototype.customEvent = function (name, info) {
        var category = JSON.stringify(info);
        this.event(name, category);
    };
    GoogleAnalytics.prototype.pageView = function (path) {
        react_ga4_1.default.send({ hitType: this.PAGE_VIEW_HINT_TYPE, page: path });
    };
    GoogleAnalytics.prototype.trace = function (_message) { };
    GoogleAnalytics.prototype.isEnabled = function () {
        return !!this.trackingIds.length;
    };
    GoogleAnalytics.prototype.eventData = function (_data) { };
    return GoogleAnalytics;
}());
exports.default = GoogleAnalytics;
